import { MyParadiseThermencardModal } from "@app/modals/MyParadise/MyParadiseThermencardModal/MyParadiseThermenCardModal"
import { useGetMyParadiseImage } from "@app/store/service/cmsService"
import { useModal } from "@tecreation/funnel-components"
import "./MyParadiseThermencard.css"

export const MyParadiseThermencard = () => {
	const { data: image } = useGetMyParadiseImage({ type: "thermencard" })
	const { showModal } = useModal()

	return (
		<div
			className="myParadiseThermencard h-100"
			style={{ backgroundImage: 'url("' + image || "" + '")' }}
			onClick={() => showModal(MyParadiseThermencardModal)}
		>
			{/* placeholder image */}
			<img src={image || ""} style={{ opacity: 0, width: "100%", height: "auto" }} />
		</div>
	)
}
